import { useSynopticStore, } from '@/assets/js/src/modules/synoptic/_pinia/synoptic'
import { getActivePinia, storeToRefs, } from 'pinia'
import { useRoute, } from 'vue-router'
import { usePrefetchData, } from '@/assets/js/src/util/composables'
import { onUnmounted, watch, } from 'vue'

export const useSynopticApi = () => {
    let synopticStore = useSynopticStore(getActivePinia())

    const { reload,synoptic, } = storeToRefs(synopticStore)
    const route = useRoute()

    const { messagesLoaded, updateData, } = usePrefetchData({
        actions: [
            {
                item: synoptic,
                action: synopticStore.getSynoptic,
                payload: function () {
                    return {
                        abbr: encodeURIComponent(route.params.abbreviation),
                        id: route.params.id,
                    }
                },
            },
        ],
        loadAsyncMessages: [ 'synoptic', 'common', ],
    })

    let triggerReload = (newValue, oldValue) => {
        newValue !== oldValue && (synopticStore.reload = true)
    }
    watch(() => route.params.id,triggerReload)
    watch(() => route.params.abbreviation,triggerReload)

    watch(reload,async (newBoolean, oldBoolean) => {
        if (newBoolean && newBoolean !== oldBoolean) {
            await updateData()
            synopticStore.reload = false
        }
    })

    onUnmounted(()=>{
        synoptic.value = {}
    })

    return {
        route,
        synoptic,
        messagesLoaded,
    }
} 
